<template>
    <div>
        <!-- Address -->
        <div class="form-group">
            <label>{{label+' '}}Street Address *</label>
            <textarea
                ref="address"

                class="form-control"
                :class="{'is-invalid': formValidated && !value.address}"

                v-model="value.address"

                @input="validateAddress"
                :disabled="disabled"
            />
            <div class="invalid-feedback">
                Street Address is required
            </div>
        </div>

        <!-- City / State-->
        <div class="form-group">
            <div class="row">
                <div class="col-lg-6 mb-lg-0 mb-3">
                    <label>{{label+' '}}City *</label>
                    <input
                        type="text"

                        ref="city"

                        class="form-control"
                        :class="{'is-invalid': formValidated && !value.city}"

                        v-model="value.city"

                        @input="validateAddress"
                        :disabled="disabled"
                    >
                    <div class="invalid-feedback">
                        City is required
                    </div>
                </div>
                <div class="col-lg-6">
                    <label>{{label+' '}}State *</label>
                    <select
                        ref="state"

                        class="form-control"
                        :class="{'is-invalid': formValidated && !value.state}"

                        v-model="value.state"

                        @change="validateAddress"
                        :disabled="disabled"
                    >
                        <option value="" selected disabled>select state</option>
                        <option v-for="state in states" :value="state.state" :key="state.state">
                            {{state.fullState}}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                        State is required
                    </div>
                </div>
            </div>
        </div>

        <!-- Zip Code -->
        <div class="form-group">
            <label>{{ label+' ' }}Zip Code *</label>
            <input
                type="text"

                ref="zip"

                class="form-control"
                :class="{'is-invalid': (formValidated && !value.zip) || (formValidated && !isValidZip(value.zip))}"

                v-model="value.zip"

                @input="validateAddress"
                :disabled="disabled"
            >
            <div class="invalid-feedback">
                Valid Zip Code is required
            </div>
        </div>

        <!-- Validation -->
        <div id="address_validation" ref="addressScrollTo">
            <div v-if="validating">
                <b-alert variant="success" class="mb-3" show>
                    <div>
                        <div>...validating address</div>
                        <div>{{value.address}}</div>
                        <div>{{value.city}}, {{value.state}}, {{value.zip}}</div>
                    </div>
                </b-alert>
            </div>

            <div v-if="showValidConfirm">
                <b-alert variant="warning" class="mb-3" show>
                    <div class="mb-2">
                        <div>{{ validatedAddress.street }}</div>
                        <div>{{ validatedAddress.city }}, {{ validatedAddress.state }}, {{ validatedAddress.zip }}</div>
                    </div>
                    <button
                        type="button"
                        class="btn btn-success mr-1"
                        @click.prevent="useSuggestedAddress"
                    >
                        Use
                    </button>
                    <button
                        type="button"
                        class="btn btn-light"
                        @click.prevent="dismissSuggestedAddress"
                    >
                        Dismiss
                    </button>
                </b-alert>
            </div>

            <div v-if="showInvalidConfirm">
                <div class="alert alert-danger mb-3">
                    <div class="mb-2">
                        <div>This address could not be validated by UPS.</div>
                    </div>
                    <div class="mb-2">
                        <div>{{value.street}}</div>
                        <div>{{value.city}}, {{value.state}}, {{value.zip}}</div>
                    </div>
                    <button
                        type="button"
                        class="btn btn-light"
                        @click.prevent="useInvalidAddress"
                    >
                        Use
                    </button>
                </div>
            </div>

            <div v-if="showAccept">
                <div class="alert alert-danger mb-3">
                    <div v-if="!validAddress" class="text-danger">
                        <strong>This address could not be validated by UPS.</strong>
                    </div>
                    <div>
                        <div class="form-check">
                            <input ref="acceptResponsibility" v-model="acceptResponsibility" type="checkbox" class="form-check-input" @click="acceptResponsibilityCheckbox" id="acceptAddressResponsibilityCheck">
                            <label class="form-check-label" for="acceptAddressResponsibilityCheck">
                                I accept responsibility for shipment to an address not validated by UPS.
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="formValidated && !acceptResponsibility" class="text-danger mb-3">
                    The Shipping Address must either be verified by UPS or you must accept responsibility for shipping to an address that is not verified by UPS.
                </div>
            </div>

            <div v-if="addressValidated">
                <div class="alert alert-success">
                    <font-awesome-icon :icon="['fas', 'check']" fixed-width  /> Shipping Address Validated
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {shippingStates} from '@/common/states'

const validatedStatuses = {
    notValid: 0,
    useSuggested: 1,
    ignoreSuggested: 2,
}

export default {
    name: "AddressForm",
    emits: ['input', 'validated'],
    props: {
        formValidated: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
        },
        validate: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "Shipping"
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        states: shippingStates,
        school: {
            address: null,
            state: null,
            zip: null,
        },

        validating: false,

        validatedAddress: {},

        addressValidated: false,
        showValidConfirm: false,
        showInvalidConfirm: false,
        showAccept: false,
        acceptResponsibility: false,

        validAddress: false,

        validatedStatus: validatedStatuses.notValid,
    }),
    methods: {
        validateAddress: _.debounce(function () {
            if (!this.validate)
                return;

            if (this.value.address && this.value.city && this.value.state && this.value.zip) {
                this.validating = true

                this.addressValidated = false

                this.axios.post("/checkout/validate/address", {
                    street: this.value.address,
                    city: this.value.city,
                    state: this.value.state,
                    zip: this.value.zip
                }).then(response => {
                    this.validating = false

                    if (!response.data)
                        return;

                    if (!response.data.success) {
                        this.validAddress = false;
                        this.showConfirmation(false);
                        return;
                    }

                    this.validatedAddress = response.data.newaddress

                    this.validAddress = true

                    if (typeof this.validatedAddress.street == "object") {
                        this.validatedAddress.street = this.validatedAddress.street.join(', ')
                    }
                    this.validatedAddress.address = this.validatedAddress.street;

                    this.showConfirmation(true);

                })
                .catch(() => {
                    this.$bvModal.msgBoxOk('There was an error validating this address. Please review and try again. \nIf the issue persists, contact customer support.', {
                        title: 'Please Confirm The Address',
                        size: 'lg',
                        buttonSize: 'md',
                        footerClass: 'p-2',
                        centered: true
                    })
                })
            }
        }, 1000),
        showConfirmation(isValid) {
            this.showValidConfirm = isValid;
            this.showInvalidConfirm = !isValid;
            this.showAccept = false;
        },
        useSuggestedAddress() {
            this.value.state = this.validatedAddress.state;
            this.value.zip = this.validatedAddress.zip;
            this.value.city = this.validatedAddress.city;
            this.value.address = this.validatedAddress.street;
            this.validatedStatus = validatedStatuses.useSuggested;

            this.$emit('validated', true, this.validatedStatus);

            this.showValidConfirm = false;
            this.addressValidated = true;
        },
        dismissSuggestedAddress() {
            this.showValidConfirm = false;
            this.showAccept = true;
            this.validatedStatus = validatedStatuses.ignoreSuggested;
        },
        useInvalidAddress() {
            this.validatedStatus = validatedStatuses.notValid;
            this.showInvalidConfirm = false;
            this.showAccept = true;
        },
        acceptResponsibilityCheckbox() {
            this.$emit('validated', false, this.validatedStatus);
        },
        isValidZip(zip) {
            return /^\d{5}(-\d{4})?$/.test(zip);
        }

    },
    watch: {
        value: {
            handler(newValue) {
                this.$emit('input', newValue);
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>